// extracted by mini-css-extract-plugin
export default {"menuContainer":"SideMenu_menuContainer__nXHQJ","subMenu":"SideMenu_subMenu__Jc3Kv","closeIcon":"SideMenu_closeIcon__yFyqa"};